import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Parametric = x => x;
const udecodeParametric = dictDecode => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "values"})(Unscramble.decodeMap({
      fromJSONKey: Unscramble.$FromJSONKeyFunction(
        "FromJSONKeyValue",
        Unscramble.decodeMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ufromJSONKeyParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.unscrambleDecodeParameterChoiceId).unsafeDecode
      )
    })(Data$dMap$dInternal.ordMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.ordParameterChoiceId))(dictDecode))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
);
const showParametric = dictShow => {
  const $0 = Data$dMap$dInternal.showMap(Data$dMap$dInternal.showMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.showParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.showParameterChoiceId))(dictShow);
  return {
    show: record => {
      const v = Data$dShow.cons(Data$dShow.intercalate(": ")(["values", $0.show(record.values)]))([]);
      if (v.length === 0) { return "{}"; }
      return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
    }
  };
};
const newtypeParametric = {Coercible0: () => {}};
const eqParametric = dictEq => (
  {
    eq: (() => {
      const $0 = Data$dMap$dInternal.eqMap(Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.eqParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.eqParameterChoiceId))(dictEq);
      return ra => rb => $0.eq(ra.values)(rb.values);
    })()
  }
);
const encodeParametric = dictEncode => dictGenericEncodeArgs => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "values"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap({
        asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction(
          "AsJSONKeyValue",
          Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.asJSONKeyParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.encodeParameterChoiceId)({
            encodeArgs: opts => v => Data$dList$dTypes.$List(
              "Cons",
              Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.encodeParameterChoiceId.encode(v)),
              Data$dList$dTypes.Nil
            )
          }).encode,
          Data$dMap$dSerialized.decodeMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.asJSONKeyParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.decodeParameterChoiceId)({
            decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.decodeParameterChoiceId.decode}),
            decodeSingleRecordArg: Data$dMaybe.Nothing
          }).decode
        )
      })(dictEncode)(dictGenericEncodeArgs);
      return {encodeWithOptions: v => $0.encode};
    })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
);
const decodeParametric = dictDecode => dictGenericDecodeArgs => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({reflectSymbol: () => "values"})((() => {
      const $0 = Data$dMap$dSerialized.decodeMap(Data$dMap$dInternal.ordMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.ordParameterChoiceId))({
        asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction(
          "AsJSONKeyValue",
          Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.asJSONKeyParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.encodeParameterChoiceId)({
            encodeArgs: opts => v => Data$dList$dTypes.$List(
              "Cons",
              Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.encodeParameterChoiceId.encode(v)),
              Data$dList$dTypes.Nil
            )
          }).encode,
          Data$dMap$dSerialized.decodeMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.asJSONKeyParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.decodeParameterChoiceId)({
            decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.decodeParameterChoiceId.decode}),
            decodeSingleRecordArg: Data$dMaybe.Nothing
          }).decode
        )
      })(dictDecode)(dictGenericDecodeArgs);
      return {decodeWithOptions: v => $0.decode};
    })())()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
);
export {Parametric, decodeParametric, encodeParametric, eqParametric, newtypeParametric, showParametric, udecodeParametric};
